<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('all_tenants')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('add', 'tenant', true)"
                          @click="isTenantCreateOpenModalActive = true"
                          v-if="$can('add_tenants')"
      />
<!--      <app-default-button-->
<!--          v-if="$can('invite_employees')"-->
<!--          @click="isModalActive = true"-->
<!--          :title="$fieldTitle('invite', 'employee', true)"/>-->
    </app-page-top-section>

    <app-table
        id="tenant-table"
        :options="options"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

<!--    <app-employee-invite-->
<!--        v-if="isModalActive"-->
<!--        v-model="isModalActive"-->
<!--        :selected-url="selectedUrl"-->
<!--    />-->

    <app-tenant-create-edit-model
        v-if="isTenantCreateOpenModalActive "
        v-model="isTenantCreateOpenModalActive"
        :selected-url="selectedUrl"
        :company-size='companySize'
        :industry='industry'
    />


    <app-confirmation-modal
        :title="promptTitle"
        :message="promptMessage"
        :modal-class="modalClass"
        :icon="promptIcon"
        v-if="confirmationModalActive"
        modal-id="app-confirmation-modal"
        @confirmed="triggerConfirm"
        @cancelled="cancelled"
        :loading="loading"
        :self-close="false"
    />

    <!--    <app-confirmation-modal-->
<!--        :title="promptTitle"-->
<!--        :message="promptMessage"-->
<!--        :modal-class="modalClass"-->
<!--        :icon="promptIcon"-->
<!--        v-if="confirmationModalActive"-->
<!--        modal-id="app-confirmation-modal"-->
<!--        @confirmed="triggerConfirm"-->
<!--        @cancelled="cancelled"-->
<!--        :loading="loading"-->
<!--        :self-close="false"-->
<!--    />-->

<!--    <app-employment-status-modal-->
<!--        v-if="employmentStatusModalActive"-->
<!--        v-model="employmentStatusModalActive"-->
<!--        :id="employeeId"-->
<!--    />-->

<!--    <app-employee-termination-reason-modal-->
<!--        v-if="isTerminationReasonModalActive"-->
<!--        v-model="isTerminationReasonModalActive"-->
<!--        :id="employeeId"-->
<!--    />-->

<!--    <employee-context-menu-->
<!--        v-if="isContextMenuOpen"-->
<!--        :employees="selectedEmployees"-->
<!--        @close="isContextMenuOpen = false"-->
<!--    />-->

<!--    <app-attendance-create-edit-modal-->
<!--        v-if="attendanceModalActive"-->
<!--        v-model="attendanceModalActive"-->
<!--        :employee="employee"-->
<!--    />-->

<!--    <app-leave-create-edit-modal-->
<!--        v-if="leaveModalActive"-->
<!--        v-model="leaveModalActive"-->
<!--        :employee="employee"-->
<!--    />-->

<!--    <job-history-edit-modal-->
<!--        v-if="isJobHistoryEditModalActive"-->
<!--        v-model="isJobHistoryEditModalActive"-->
<!--        :modalType="modalAction"-->
<!--        :employee="employee"-->
<!--        @reload="reloadEmployeeTable"-->
<!--    />-->

  </div>
</template>

<script>
import TenantMixin from "../../Mixins/TenantMixin";
// import EmployeeContextMenu from "./Components/EmployeeContextMenu";
// import JobHistoryEditModal from "./Components/JobHistory/components/JobHistoryEditModal";
// import {axiosGet} from "../../../../common/Helper/AxiosHelper";
// import EmployeeCreateEditModel from "./EmployeeCreateEditModal"

export default {
  components: {},
  mixins: [TenantMixin],
  props: {
    companySize: {
      type: Array,
      default: []
    },
    industry: {
      type: Array,
      default: []
    },
  },
  mounted() {
  },
  methods:{

  }
}
</script>
